import React from 'react';

import ProductListPageSkeleton from '../../components/skeleton/ProductListPageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const MANUFACTURER_PAGE_CHUNK_NAME = 'manufacturerPage';

export const ManufacturerPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "manufacturerPage" */ '../../pages/ManufacturerPage'
    ),
  {
    fallback: <ProductListPageSkeleton variant="manufacturer" />,
  }
);
